// No React import needed for this component
import clsx from 'clsx';
import GuestSidebar from './GuestSidebar';
import type { GuestLayoutProps } from '../../types/layout';

function GuestLayout({
  children,
  title,
  showAuthButtons = true,
  className,
}: GuestLayoutProps) {
  return (
    <div className={clsx('app-container flex min-h-screen', className)}>
      {/* Set page title */}
      {/* eslint-disable lingui/no-unlocalized-strings */}
      {title && <title>{title} - Instapaper</title>}
      {/* eslint-enable lingui/no-unlocalized-strings */}

      {/* Sidebar — reuses the app rail chrome so the guest view matches the
          authenticated sidebar */}
      {showAuthButtons && (
        <div className="side-nav-container md:translate-x-0">
          <GuestSidebar />
        </div>
      )}

      {/* Main content */}
      <main id="main-content" className="flex-fluid min-h-screen bg-white outline-none">
        {children}
      </main>
    </div>
  );
}

export default GuestLayout;
